export const Banner = () => {
  return (
    <>
      <div>
        <div
          className={`
            hidden

            md:block
          `}
        >
          <div
            className={`
              relative h-28 w-full rounded-lg bg-primary-700 overflow-hidden
            `}
          >
            <div className="absolute inset-0">
              <img
                src="/img/Banner/BannerNuestros.jpeg"
                alt="Vehicle background large"
                className={`
                  h-36 w-full rounded-lg object-cover object-[center_87%]
                `}
              />
            </div>

            <div
              className={`absolute inset-0 flex items-center justify-start px-6`}
            >
              <div className="flex flex-col gap-2">
                <h3 className="text-h4 text-white">
                  ¿Tienes dudas sobre un vehículo?
                </h3>
                <p className="text-h5-medium text-white">
                  Estamos aquí para ayudarte.
                </p>
              </div>

              <div className="flex items-center pl-[170px]">
                <div className="relative h-6 w-6 flex-shrink-0">
                  <img
                    src="/img/Banner/phone-call-01.png"
                    alt="Phone Icon"
                    className="absolute inset-0 z-20 m-auto h-6 w-6"
                  />
                </div>
                <p className="ml-3 text-nowrap text-h4 text-white">
                  931 318 618
                </p>
              </div>
            </div>
          </div>
        </div>
        <div
          className={`
            block

            md:hidden
          `}
        >
          <div
            className={`
              relative h-[355px] w-full rounded-lg bg-primary-700
              overflow-hidden
            `}
          >
            <div className="absolute inset-0">
              <img
                src="/img/Banner/BannerNuestros.jpeg"
                alt="Vehicle background small"
                className="h-full w-full rounded-lg object-cover object-right"
              />
            </div>
            <div
              className={`
                absolute inset-0 flex flex-col items-center justify-start p-6
                pt-12
              `}
            >
              <div className="mb-4 text-center">
                <h4 className="text-h4 text-white">
                  ¿Tienes dudas sobre un vehículo?
                </h4>
                <p className="text-h5-medium text-white">
                  Estamos aquí para ayudarte.
                </p>
              </div>

              <div className="flex w-full items-center justify-center">
                <div className="flex items-center">
                  <div className="relative h-6 w-6 flex-shrink-0">
                    <img
                      src="/img/Banner/phone-call-01.png"
                      alt="Phone Icon"
                      className="absolute inset-0 z-20 m-auto h-6 w-6"
                    />
                  </div>
                  <p className="ml-3 text-nowrap text-h4 text-white">
                    931 318 618
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
